import { IntercomTracker as BaseIntercomTracker } from "@nimble/react-trackers/intercom-tracker";

import { publicEnv } from "@/env/public-env";
import { useAuth } from "@/stores/use-auth";

export default function IntercomTracker({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isLoading, user } = useAuth();

  return (
    <BaseIntercomTracker
      appId={publicEnv.NEXT_PUBLIC_INTERCOM_ID || ""}
      currentApplication="connect"
      isLoading={isLoading}
      user={user}
    >
      {children}
    </BaseIntercomTracker>
  );
}
